import { uiText } from './text';

/**
 * The loading screen written in index.html, so that it shows before any of
 * the game's code has arrived. From here the game fills its bar with real
 * progress, names what it waits for, and lifts it once there is something
 * to see: the welcome screen, the roster, or the world.
 */

const FADE_MS = 300;

function root(): HTMLElement | null {
  return document.getElementById('loader');
}

/** Put the screen back up (between the welcome screen and the world). */
export function showLoader(caption = 'Chargement'): void {
  const loader = root();
  if (loader === null) return;
  loader.hidden = false;
  loader.classList.remove('loader--gone');
  setLoaderCaption(caption);
}

/** Fill the bar to `fraction` (0 to 1); the sweeping block gives way to it. */
export function setLoaderProgress(fraction: number): void {
  const loader = root();
  if (loader === null) return;
  loader.classList.remove('loader--waiting');
  const cells = loader.querySelectorAll('.loader__cell');
  const lit = Math.round(Math.min(1, Math.max(0, fraction)) * cells.length);
  cells.forEach((cell, i) => cell.classList.toggle('loader__cell--on', i < lit));
}

export function setLoaderCaption(caption: string): void {
  const text = root()?.querySelector('.loader__caption');
  if (text) text.textContent = uiText(caption);
}

/** Fade the screen out; it stays in the page, ready for `showLoader`. */
export function hideLoader(): void {
  const loader = root();
  if (loader === null || loader.classList.contains('loader--gone')) return;
  loader.classList.add('loader--gone');
  window.setTimeout(() => {
    if (loader.classList.contains('loader--gone')) loader.hidden = true;
  }, FADE_MS);
}
